import React from "react";
import buttonBackground from "../images/button-background.png";

function TopicButton({ text, onClick }) {
  return (
    <div className="relative">
      <div
        className="w-72 h-40 sm:w-64 sm:h-48 rounded-md cursor-pointer transform flex items-center justify-center relative z-10 shadow-[8px_8px_0px_#137472] hover:translate-x-[5px] hover:translate-y-[5px] hover:shadow-[3px_3px_0px_#137472] hover:cursor-pointer active:translate-x-[2px] active:translate-y-[2px] active:shadow-[6px_6px_0px_#137472] mobile-transition touch-target no-select focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
        style={{
          backgroundImage: `url(${buttonBackground})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
      >
        <div className="text-center px-4">
          <div className="text-white font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight">
            {text}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopicButton;
